import React, { useState } from 'react';
import { Size, Color, Icon, Link, Button } from '@americanexpress/aqx-components';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import { formatDtmObj } from './utils';
import styles from './__styles__/index.scss?modules';

const AqxIcon = ({ imageName, open }) => (
  <Icon
    directory="dls"
    imageName={imageName}
    $size={Size.MD}
    theme={{
      color: open ? Color.DeepBlue : Color.BrightBlue
    }}
  />
);

const Modal = ({ open, children }) => (
  <dialog className={styles.subNavModal} open={open}>
    {children}
  </dialog>
);

const Header = ({ children, open, onClick, ariaLabel }) => (
  <header className={styles.subNavHeader}>
    {children}
    <div className={styles.iconBox}>
      <Button
        className={styles.headerButton}
        onClick={onClick}
        aria-label={ariaLabel}
        aria-expanded={open}
        aria-haspopup="dialog"
      >
        <AqxIcon imageName={`dls-icon-more${open ? '-filled' : ''}`} />
      </Button>
    </div>
  </header>
);

const Menu = ({ content, children, icon, dtmExpand, dtmCollapse }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuClick = () => {
    setMenuOpen(!menuOpen);
    sendDTMClickEvent(formatDtmObj(menuOpen ? dtmCollapse : dtmExpand));
  };
  return (
    <li className={styles.menuLi}>
      <Button
        onClick={menuClick}
        className={menuOpen ? styles.menuButtonOpen : styles.menuButton}
        aria-expanded={menuOpen}
      >
        <div className={styles.buttonHeader}>
          {icon?.(menuOpen)}
          <p
            className={
              menuOpen ? styles.menuParagraphOpen : styles.menuParagraphClosed
            }
          >
            {content}
          </p>
          {menuOpen ? (
            <AqxIcon imageName="dls-icon-up" />
          ) : (
            <AqxIcon imageName="dls-icon-down" />
          )}
        </div>
      </Button>
      {menuOpen && <ul className={styles.menuList}>{children}</ul>}
    </li>
  );
};

const SubnavLink = ({ children, href, icon }) => (
  <li className={styles.linkLi}>
    <a href={href} className={styles.linkA}>
      {icon}
      <p className={styles.linkP}>{children}</p>
    </a>
  </li>
);

const CallbackCta = ({ content, phoneNumber, ctaDtm }) => {
  return (
    <div className={styles.ctaBox}>
      <hr className={styles.ctaHr} />
      <div className={styles.ctaLine}>
        <p className={styles.ctaParagraph}>{content}</p>
        <Link
          onClick={() => sendDTMClickEvent(formatDtmObj(ctaDtm))}
          className={styles.ctaLink}
          href={`tel:+${phoneNumber}`}
        >
          {phoneNumber}
        </Link>
      </div>
    </div>
  );
};

export const SubNav = {
  AqxIcon,
  Modal,
  Header,
  Menu,
  SubnavLink,
  CallbackCta
};
